import type { FieldDefinition } from "@estelle/domain";

/** How many filters a list offers as chips by default (#633). */
export const COMMON_FILTER_COUNT = 4;

/**
 * The fields a list offers as chips under its search box (#633): the ones the
 * section names (`SectionUi.commonFilters`), else the first four that have a
 * short set of answers — a status, a yes/no, a date, tags. A free-text field is
 * what the search box is for, so it is never a default chip.
 */
export function commonFilterFields(
  fields: readonly FieldDefinition[],
  named: readonly string[] | undefined,
): FieldDefinition[] {
  const filterable = fields.filter((field) => field.filterable !== false);
  if (named && named.length > 0) {
    return named
      .map((name) => filterable.find((field) => field.name === name))
      .filter((field): field is FieldDefinition => field !== undefined);
  }
  return filterable
    .filter(
      (field) =>
        field.type === "enum" ||
        field.type === "boolean" ||
        field.type === "date" ||
        field.type === "datetime" ||
        field.type === "tag",
    )
    .slice(0, COMMON_FILTER_COUNT);
}

/**
 * Every filterable field, split into the common ones (in the order given) and
 * the rest (in declaration order), for "+ Filter" and the phone's "All filters".
 */
export function groupFields(
  fields: readonly FieldDefinition[],
  common: readonly FieldDefinition[],
): { common: FieldDefinition[]; more: FieldDefinition[] } {
  const names = new Set(common.map((field) => field.name));
  return {
    common: [...common],
    more: fields.filter(
      (field) => field.filterable !== false && !names.has(field.name),
    ),
  };
}
